// chartRegistry.js

export const CHART_REGISTRY = {
    incident: {
        key: "incident",
        title: "장애 차트",
        datasets: [
            {
                datasetKey: "incidentCode",
                title: "장애 유형 분포",
                headerTokens: ["유형명", "건수"],
                charts: ["pie"],
                valueLabel: "건수",
            },
            {
                datasetKey: "statusKorValue",
                title: "진행 단계 분포",
                headerTokens: ["진행", "건수"],
                charts: ["bar"],
                valueLabel: "건수",
            },
        ],
    },
    inspection: {
        key: "inspection",
        title: "점검 차트",
        datasets: [
            {
                datasetKey: "inspectionCode",
                title: "점검 유형 분포",
                headerTokens: ["유형명", "건수"],
                charts: ["pie"],
                valueLabel: "건수",
            },
            {
                datasetKey: "statusKorValue",
                title: "진행 단계 분포",
                headerTokens: ["진행", "건수"],
                charts: ["bar"],
                valueLabel: "건수",
            },
        ],
    },
    work: {
        key: "work",
        title: "작업 차트",
        datasets: [
            {
                datasetKey: "workCode",
                title: "작업 유형 분포",
                headerTokens: ["유형명", "건수"],
                charts: ["pie"],
                valueLabel: "건수",
            },
            {
                datasetKey: "statusKorValue",
                title: "진행 단계 분포",
                headerTokens: ["진행", "건수"],
                charts: ["bar"],
                valueLabel: "건수",
            },
        ],
    },
    service: {
        key: "service",
        title: "접수 차트",
        datasets: [
            {
                datasetKey: "serviceCode",
                title: "업무 그룹 분포",
                headerTokens: ["유형명", "건수"],
                charts: ["pie"],
                valueLabel: "건수",
            },
            {
                datasetKey: "statusKorValue",
                title: "진행 단계 분포",
                headerTokens: ["진행", "건수"],
                charts: ["bar"],
                valueLabel: "건수",
            },
        ],
    },
};

export function buildChartConfigs(keys) {
    const key = Array.isArray(keys) ? keys[0] : keys;
    const registry = CHART_REGISTRY[key];
    if (!registry) return [];

    const datasets = Array.isArray(registry.datasets) ? registry.datasets : [];
    const out = [];

    for (const ds of datasets) {
        const charts = Array.isArray(ds.charts) ? ds.charts : [];
        for (const chartType of charts) {
            out.push({
                registryKey: registry.key,
                datasetKey: ds.datasetKey,
                title: ds.title,
                kind: chartType, // "pie" | "bar"
                headerTokens: ds.headerTokens,
                valueLabel: ds.valueLabel || "건수",
            });
        }
    }

    return out;
}